import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Route } from 'react-router-dom';
import HeaderSample from "../common/headerSample";
import Button from 'react-bootstrap/Button';
import OrderDashboard from "./orderDashboard";
import { WebcamCapture } from "../common/camera";
import { URL, USER } from "../../constants/constant";
import FormData from "form-data";
import {_axios} from '../../plugins/axios'
import ToasterComponent from "../common/toaster";
import { geolocated } from "react-geolocated";
import { Form, Modal } from "react-bootstrap";
import PackageDetails  from "../common/packageDetails"

class OrderDetails extends Component {
    constructor(props) {
        super(props);
        console.log(this.props)
        this.state = {
            reassignLab: false,
            userdata: USER.user,
            orderStatus: null,
            orderDetails: null,
            cameraToggle: false,
            sampleCollection: localStorage.getItem("phlebo_start_order_trip_details") ? JSON.parse(localStorage.getItem("phlebo_start_order_trip_details")) : null,
            orderId: this.props.match.params.orderId,
            showSnackbar: false,
            messageSnacks: '',
            showReachedButton: localStorage.getItem("phlebo_start_order_trip_details") ? false : true,
            acceptDisable: true,
            lat: '11.0553N',    //pass the latitude
            lon: '76.9940E',   //pass the longitude
            location: '4, opp to fire station, 1, Bannerghatta Main Rd, Bengaluru, Karnataka 560029', //pass the location
            loader: true,
            latitude : "0.0",
            longitude: "0.0",
            labCentersAvailable: [],
            labAssigned: true,
            labId: null,
            showPackageInfo: false,
            loadPackageDetails: false,
            bulkSelectedSPCModal: false,
            bulkSelectedAcceptModal: false,
            bulkSelectedTripStartModal: false,
            bulkSelectedReachedModal: false,
            bulkSelectedSPCUpdate: [],
            bulkSelectedAcceptUpdate: [],
            bulkSelectedTripStartUpdate: [],
            bulkSelectedReachedUpdate: [],
            allOrders: [],
            tripStartSampleGuid: [],
            isLoader: false,
            latlongEventTriggerFunction : (ev) => {
                const that = this;
                console.log("lat long received event triggered",ev.detail);
            
                if (ev.detail !== null && ev.detail !== undefined) {
                    const latlong = ev.detail.split(",");
                    console.log("lat long split in an arr ",latlong);
                    if(latlong !== null && latlong !== undefined) {
                        this.state.latitude = latlong[0]
                        this.state.longitude = latlong[1]
                        that.markOrderReached()
                    } else {
                        that.showSnackbarFun("Location not received1, cannot continue", 2500)
                    }   
                } else {
                    that.showSnackbarFun("Location not received, cannot continue", 2500)
                }
                ev.stopImmediatePropagation();
            }
        }

    }

    showPackageInfoModal(){
        this.setState({
            showPackageInfo: !this.state.showPackageInfo
        })
    }

    addEventListeners() {
        if (typeof android !== "undefined" && android !== null) {
            window.addEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
            console.log("addEventListeners : ", this.state.latlongEventTriggerFunction);
        }
    }

    cleanupListener() {
        if (typeof android !== "undefined" && android !== null) {
            window.removeEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
            console.log("cleanupListener : ", this.state.latlongEventTriggerFunction);
        }
    }

    getLabCenters() {
        const that = this;
        that.setState({
            loader : true
        })
        let route = URL.dev_url + 'getAllSPCByCity?city=' + USER.user.city
        _axios.get(route).then(function(res) {
            that.setState({
                loader : false,
                labCentersAvailable: res.data,
            })
        }).catch(function(err) {
            console.log(error);
            that.setState({
                loader : false,
                labAssigned: false
            })
        })
    }

    
    componentDidMount() {
        this.addEventListeners();
        this.getOrderDetails()
    }

    componentWillUnmount() {
        this.cleanupListener();
    }

    showSnackbarFun(message, timeout){
        this.setState({
            messageSnacks: message,
            showSnackbar: true
        }, () => {
            this.toastComponent();
        })
        setTimeout(() => {
            this.setState({
                messageSnacks: "",
                showSnackbar: false,
            })
        }, timeout)
    }

    toastComponent() {
        return <ToasterComponent show={this.state.showSnackbar ? this.state.showSnackbar : ''} message={this.state.messageSnacks ? this.state.messageSnacks : ''}></ToasterComponent>;
    }


    getOrderDetails() {
        const that = this;
        let currOrderId = parseInt(this.props.match.params.orderId)
        let url = URL.dev_url;
        let route = url + 'getorders'
        let obj = {
            phleboId: this.state.userdata.phleboId,
        }

        that.setState({
            loader : true
        })

        _axios.post(route, obj)
            .then(function (response) {

                if (response.data.success) {
                    USER.orderDetails = {...response.data}; 
                    USER.orderDetails.pendingOrders = response.data.pendingOrders.filter(data => data.orderId == currOrderId)
                    if (USER.orderDetails.pendingOrders[0].orderStatus.currentStatusId == 2 || USER.orderDetails.pendingOrders[0].orderStatus.currentStatusId == 201) {
                        that.setState({
                            acceptDisable: false
                        });
                    }
                    console.log(USER.orderDetails.pendingOrders[0].orderStatus.currentStatusId)
                    if (USER.orderDetails.pendingOrders[0].orderStatus.currentStatusId == 33) {
                        that.setState({
                            showReachedButton: false
                        });
                    }
                    localStorage.setItem("order_details", JSON.stringify(USER.orderDetails));
                    that.setState({
                        orderDetails: USER.orderDetails,
                        loadPackageDetails: true,
                        allOrders: response.data.pendingOrders,
                        customerNumber: USER.orderDetails.pendingOrders[0].patientDetails[0].phoneNumber
                    }, () => {
                        localStorage.setItem('customer_phoneNumber', USER.orderDetails.pendingOrders[0].patientDetails[0].phoneNumber)
                    })
                    if(!that.state.orderDetails.pendingOrders[0].labDetails.AssignedLab){
                        that.setState({
                            labAssigned: false
                        })
                    }
                    that.getLabCenters();
                }   
            }).catch(function (error) {
                console.log(error);
                that.setState({
                    loader : false
                })
            })
        }
    

    

    async uploadImageToS3(name, url) {
        var url = url + '';
        var arr = url.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        console.log(u8arr);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        var p = new File([u8arr], name, { type: mime });// send this file 


        var data = new FormData();
        data.append('FileName', name?.split('.')[0]);
        data.append('File', p);
        data.append('FileExtension', "jpeg");

        var config = {
            method: 'post',
            url: 'https://oms.medibuddy.in/oms/uploadFile',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data: data
        };


        const response = await _axios(config);
        console.log("guid should beb ..", response)
        let guid = Object.keys(response.data.file)[0]
        return guid;
    }

    routeToCancelPage() {
        let x = '/cancel/' + this.state.orderId;
        this.props.history.push(x);
    }

    async routeToSampleCollected() {
        // Phlebo Reached Patients home

        if (typeof android !== "undefined" && android !== null) {
            console.log("Checking location in android");
            android.startLocationTracking();
        } else {

            if (!(this.props.isGeolocationAvailable && this.props.isGeolocationEnabled)) {

                this.showSnackbarFun("Geolocation not available/enabled, Please give permissions", 4500);

            } else if (this.props.coords != undefined && this.props.coords != null
                && this.props.coords != "") {

                this.state.longitude = this.props.coords.longitude
                this.state.latitude = this.props.coords.latitude
            }

            //marking order reached from react web app even if we don't have location coords
            this.markOrderReached()
        }

    }

    markOrderReached() {
        try {
            let bulkSelectedReachedUpdate = []
            let dependantId = this.state.orderDetails.pendingOrders[0].dependantId
            let relatedOrders = this.state.allOrders.filter(data => data.dependantId == dependantId && data.orderStatus.currentStatusId == 33)
            bulkSelectedReachedUpdate = []
            relatedOrders.forEach(data => bulkSelectedReachedUpdate.push({isSelected: true, appointmentId: data.appointmentId, labtestName: data.tests[0].testName, id: data.orderId}))
            if(bulkSelectedReachedUpdate.length == 1){
                const that = this;
                let url = URL.dev_url;
                let route = url + 'updateorders'
                let obj = {
                    access_token: "trialTest" || USER.access_token,
                    currentStatusId: 3,
                    requestNextStatusId: 4,
                    phleboId: this.state.userdata.phleboId,
                    orderId: parseInt(this.props.match.params.orderId),
                    lat: parseFloat(this.state.latitude).toFixed(4).toString(),
                    long: parseFloat(this.state.longitude).toFixed(4).toString(),
                }

                _axios.post(route, obj)
                    .then(function (response) {
                        if (response.data.success) {
                            console.log("removing event listener");
                            let x = '/sample/collected/' + obj.orderId;
                            that.props.history.push(x);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    })
            } else {
                this.setState({bulkSelectedReachedUpdate : bulkSelectedReachedUpdate})
                this.setState({bulkSelectedReachedModal : true})
            }
        } catch (error) {
            console.log(error)
        }
        
    }

    renderRedirect = (orderstatus) => {
        let x = this.props.match.path + '/' + orderstatus;
        this.props.history.push(x);
        <Route path={`${this.props.match.path}/:orderStatus`} component={OrderDashboard} />
    }

    async acceptOrder() {
        let bulkSelectedAcceptUpdate = []
        let dependantId = this.state.orderDetails.pendingOrders[0].dependantId
        let relatedOrders = this.state.allOrders.filter(data => data.dependantId == dependantId && data.orderStatus.currentStatusId == 2 && data.labDetails.AssignedLabId != null)
        bulkSelectedAcceptUpdate = []
        relatedOrders.forEach(data => bulkSelectedAcceptUpdate.push({isSelected: true, appointmentId: data.appointmentId, labtestName: data.tests[0].testName, id: data.orderId}))
        if(bulkSelectedAcceptUpdate.length == 1){
            const that = this;
            let url = URL.dev_url;
            let route = url + 'updateorders'
            let obj = {
                access_token: "trialTest" || USER.access_token,
                currentStatusId: 2,
                requestNextStatusId: 3,
                phleboId: this.state.userdata.phleboId,
                orderId: parseInt(this.props.match.params.orderId)
            }

            _axios.post(route, obj)
                .then(function (response) {
                    if (response.data.success) {
                        console.log(response.data);
                    }
                    that.state.acceptDisable = true;
                    that.showSnackbarFun("Order Confirmed Successfully", 1500);
                    that.getOrderDetails();
                    
                }).catch(function (error) {
                    console.log(error);
                });
        } else {
            this.setState({bulkSelectedAcceptUpdate : bulkSelectedAcceptUpdate})
            this.setState({bulkSelectedAcceptModal : true})
        }
        
    }

    getAddrLatLoc() {
        window.location.assign(`https://maps.google.com/maps/dir//${this.state.lat},${this.state.lon}`)
    }

    // Get address through Location
    getAddrloc() {

        let destination_address = "";
        console.log("adrres", this.state.orderDetails.pendingOrders[0].patientDetails[0]);
        if (this.state.orderDetails && this.state.orderDetails.pendingOrders[0] && this.state.orderDetails.pendingOrders[0].patientDetails[0]) {
            destination_address = this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine1 ? this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine1 : '' + ' ' +
                this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine2 ? this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine2 : '' + ' ' +
                    this.state.orderDetails.pendingOrders[0].patientDetails[0].landmark ? this.state.orderDetails.pendingOrders[0].patientDetails[0].landmark : '' + ' ' +
                        this.state.orderDetails.pendingOrders[0].patientDetails[0].pincode ? this.state.orderDetails.pendingOrders[0].patientDetails[0].pincode : '';
        }

        if (typeof android !== "undefined" && android !== null) {
            console.log("starting navigation in android");
            android.startNavigation(destination_address);
        } else {
            window.location.assign(`https://maps.google.com/maps/dir//${destination_address}`)
        }
    }

    handleCameraToggle() {
        const that = this;
        let testDetailsTemp = {};
        testDetailsTemp["cameraToggle"] = true;
        testDetailsTemp["b64"] = null;
        testDetailsTemp["imageUploaded"] = null;
        this.setState({
            sampleCollection: testDetailsTemp,
        }, () => {
            that.checkCamera()
        })
    }

    callback = async (sampleValues) => {
        // do something with value in parent component, like save to state
        console.log("child value::", sampleValues.b64);
        this.setState({
            sampleCollection: sampleValues
        })
        if (sampleValues.imageUploaded) {
            this.startTrip();
        }
        console.log(this.state.sampleCollection);
    }


    checkCamera() {
        if (this.state.sampleCollection) {
            if (!this.state.sampleCollection.imageUploaded) {
                if (this.state.sampleCollection.cameraToggle)
                    return (
                        <div>
                        <WebcamCapture multipleImages={true} cameraFace="user" dataParentToChild={this.state.sampleCollection} parentCallback={this.callback} />
                        <div className="text-align-center p-10">Click on <b>Capture</b> to take selfie, then click on <b>Stop</b></div>
                        </div>
                    )
            }
        }
    }

    async startTrip() {

        let guid = null;
        let sampleGuids = [];

        if (this.state.sampleCollection && this.state.sampleCollection.imageUploaded) {
            if (this.state.sampleCollection.b64) {
                for (let i = 0; i < this.state.sampleCollection.b64.length; i++) {
                    let name = this.state.orderId + '_phleboid_' + this.state.phleboId + '_' + i + '_User_image' + '.jpeg'
                    guid = await this.uploadImageToS3(name, this.state.sampleCollection.b64[i]);
                    sampleGuids.push(guid);
                }
            }
        }
        this.setState({ tripStartSampleGuid: sampleGuids })

        let bulkSelectedTripStartUpdate = []
        let dependantId = this.state.orderDetails.pendingOrders[0].dependantId
        let relatedOrders = this.state.allOrders.filter(data => data.dependantId == dependantId && data.orderStatus.currentStatusId == 3)
        bulkSelectedTripStartUpdate = []
        relatedOrders.forEach(data => bulkSelectedTripStartUpdate.push({isSelected: true, appointmentId: data.appointmentId, labtestName: data.tests[0].testName, id: data.orderId}))
        if(bulkSelectedTripStartUpdate.length == 1){
            const that = this;
            console.log(this.state.sampleCollection);
            console.log(this.state.sampleCollection.guid);
            let url = URL.dev_url;
            let route = url + 'updateorders'
            let obj = {
                access_token: "trialTest" || USER.access_token,
                currentStatusId: 2,
                requestNextStatusId: 33,
                phleboId: this.state.userdata.phleboId,
                orderId: parseInt(this.props.match.params.orderId),
                orderConfirmationImageGuids: sampleGuids
            }

            _axios.post(route, obj)
                .then(function (response) {
                    if (response.data.success) {
                        console.log("Start Trip", response.data.message);
                        that.setState({
                            showReachedButton: false,
                            messageSnacks: "Image Uploaded Successfully",
                            showSnackbar: true,
                        }, () => {
                            localStorage.setItem("phlebo_start_order_trip_details", JSON.stringify(that.state.sampleCollection));
                            that.toastComponent();
                        })
                        that.getOrderDetails();
                    }
                }).catch(function (error) {
                    console.log(error);
                })
        } else {
            this.setState({bulkSelectedTripStartUpdate : bulkSelectedTripStartUpdate})
            this.setState({bulkSelectedTripStartModal : true})
        }
    }

    handleLabCenterChange(event) {
        event.preventDefault();
        this.setState({labId: event.target.value});
    }

    async updateLabCenter(val, e) {
        e.preventDefault()
        if(!this.state.labId) {
            this.showSnackbarFun("Please select lab center", 3000);
            return
        }
        let bulkSelectedSPCUpdate = []
        let dependantId = this.state.orderDetails.pendingOrders[0].dependantId
        let relatedOrders = this.state.allOrders.filter(data => data.dependantId == dependantId && data.labDetails.AssignedLabId == null)
        bulkSelectedSPCUpdate = []
        relatedOrders.forEach(data => bulkSelectedSPCUpdate.push({isSelected: true, appointmentId: data.appointmentId, labtestName: data.tests[0].testName, id: data.orderId}))
        if(bulkSelectedSPCUpdate.length == 1){
            await _axios.post(URL.dev_url + 'updateSPCForOrderId', {
                "orderId": this.state.orderDetails.pendingOrders[0].orderId,
                "spcId" : this.state.labId
            })
            window.location.reload();
            this.setState({
                labAssigned: true
            })
        } else {
            this.setState({bulkSelectedSPCUpdate : bulkSelectedSPCUpdate})
            this.setState({bulkSelectedSPCModal : true})
        }
        
    }

    showImage() {
        if (this.state.sampleCollection) {
            if (this.state.sampleCollection.imageUploaded) {
                return (
                    <div>
                        {
                            this.state.sampleCollection.b64 ? this.state.sampleCollection.b64.map((elem, index) => (
                                <div key={index} className="w-100 text-align-center p-b-10">
                                    <img class="w-100 text-align-center p-b-10" src={elem}></img>
                                </div>
                            )) : ''
                        }
                    </div>
                )
            }
        }
    }

    navigateToReschedule(id, time, reqId, city, DID, providerOrderId, name) {
        console.log(id, time);
        localStorage.setItem("AppointmentDate", JSON.stringify(time));
        localStorage.setItem("AppointmentId", JSON.stringify(reqId));
        localStorage.setItem("City", JSON.stringify(city));
        localStorage.setItem("DID", JSON.stringify(DID));
        localStorage.setItem("providerOrderId", JSON.stringify(providerOrderId));
        localStorage.setItem("name", JSON.stringify(name));
        let routerLink = '/sample/collected/Reschedule/'+id;
        this.props.history.push(routerLink);
    }

    markBulkSPCupdate(id, e){
        const relatedOrders = this.state.bulkSelectedSPCUpdate
        for(let data of relatedOrders){
            if(data.id == id){
                data.isSelected = !data.isSelected
                break
            }
        }
        this.setState({bulkSelectedSPCUpdate: relatedOrders})
    }

    markBulkAcceptUpdate(id, e){
        const relatedOrders = this.state.bulkSelectedAcceptUpdate
        for(let data of relatedOrders){
            if(data.id == id){
                data.isSelected = !data.isSelected
                break
            }
        }
        this.setState({bulkSelectedAcceptUpdate: relatedOrders})
    }

    markBulkTripStartUpdate(id, e){
        const relatedOrders = this.state.bulkSelectedTripStartUpdate
        for(let data of relatedOrders){
            if(data.id == id){
                data.isSelected = !data.isSelected
                break
            }
        }
        this.setState({bulkSelectedTripStartUpdate: relatedOrders})
    }

    markBulkReachedUpdate(id, e){
        const relatedOrders = this.state.bulkSelectedReachedUpdate
        for(let data of relatedOrders){
            if(data.id == id){
                data.isSelected = !data.isSelected
                break
            }
        }
        this.setState({bulkSelectedReachedUpdate: relatedOrders})
    }

    async updateSPCToOrder(){
        if(!this.state.labId) {
            this.showSnackbarFun("Please select lab center", 3000);
            return
        }
        this.setState({isLoader: true})
        let route = URL.dev_url + 'updateSPCForOrderId'
        for(let order of this.state.bulkSelectedSPCUpdate){
            if (order.isSelected){
                await _axios.post(route, {
                    "orderId": order.id,
                    "spcId" : this.state.labId
                })
            }
        }
        window.location.reload();
        this.setState({
            labAssigned: true,
            isLoader: false
        })
        
    }

    async updateAcceptOrderBulk(){
        try {
            this.setState({bulkSelectedAcceptModal : false})
            for(let order of this.state.bulkSelectedAcceptUpdate){
                if(!order.isSelected) continue
                let url = URL.dev_url;
                let route = url + 'updateorders'
                let obj = {
                    access_token: "trialTest" || USER.access_token,
                    currentStatusId: 2,
                    requestNextStatusId: 3,
                    phleboId: this.state.userdata.phleboId,
                    orderId: parseInt(order.id)
                }
                let response = await _axios.post(route, obj)
                if (!response.data.success) {
                    throw new Error("Something went wrong")
                }
            }
            this.state.acceptDisable = true;
            this.showSnackbarFun("Order Confirmed Successfully", 1500);
            this.getOrderDetails();
            this.setState({bulkSelectedAcceptModal : false, isLoader: false})
        } catch (error) {
            this.showSnackbarFun("Something went wrong!!!", 1500);
            this.setState({bulkSelectedAcceptModal : false, isLoader: false})
        }
        
        
    }

    async updateTripStartOrderBulk(){
        try {
            this.setState({bulkSelectedTripStartModal: false})
            let isCurrentOrderDone = false
            let firstPromise = [], secondPromise = [], index = 0
            for(let order of this.state.bulkSelectedTripStartUpdate){
                if(!order.isSelected) continue
                if(order.id == parseInt(this.props.match.params.orderId)) isCurrentOrderDone = true
                const that = this;
                let url = URL.dev_url;
                let route = url + 'updateorders'
                let obj = {
                    access_token: "trialTest" || USER.access_token,
                    currentStatusId: 2,
                    requestNextStatusId: 33,
                    phleboId: this.state.userdata.phleboId,
                    orderId: order.id,
                    orderConfirmationImageGuids: this.state.tripStartSampleGuid
                }
                if(index == 0){
                    firstPromise.push(_axios.post(route, obj))
                } else {
                    secondPromise.push(_axios.post(route, obj))
                }
                index += 1
            }
            await Promise.all(firstPromise)
            await Promise.all(secondPromise)
            isCurrentOrderDone ? this.setState({
                showReachedButton: false,
                messageSnacks: "Image Uploaded Successfully",
                showSnackbar: true,
                bulkSelectedTripStartModal : false,
                isLoader: false
            }, () => {
                localStorage.setItem("phlebo_start_order_trip_details", JSON.stringify(this.state.sampleCollection));
                this.toastComponent();
            }) : this.setState({isLoader: false, sampleCollection: { imageUploaded: null}, bulkSelectedTripStartModal: false})
            this.getOrderDetails();
        } catch (error) {
            this.showSnackbarFun("Something went wrong!!!", 1500);
            this.setState({bulkSelectedTripStartModal : false, isLoader: false})
        }
        
        
    }

    async updateReachedOrderBulk(){
        try {
            this.setState({bulkSelectedReachedModal: false})
            let isCurrentOrderDone = false
            for(let order of this.state.bulkSelectedReachedUpdate){
                if(!order.isSelected) continue
                let url = URL.dev_url;
                let route = url + 'updateorders'
                let obj = {
                    access_token: "trialTest" || USER.access_token,
                    currentStatusId: 3,
                    requestNextStatusId: 4,
                    phleboId: this.state.userdata.phleboId,
                    orderId: order.id,
                    lat: parseFloat(this.state.latitude).toFixed(4).toString(),
                    long: parseFloat(this.state.longitude).toFixed(4).toString(),
                }

                let response = await _axios.post(route, obj)
                if (!response.data.success) {
                    throw new Error("Something went wrong")
                }
            }
            let x = '/sample/collected/' + this.props.match.params.orderId;
            this.props.history.push(x);
        } catch (error) {
            this.showSnackbarFun("Something went wrong!!!", 1500);
            this.setState({bulkSelectedReachedModal : false, isLoader: false})
        }
        
        
    }
    

    render() {

        return (
            <div>
                <div className="main">
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkSelectedSPCModal}
                    onHide={() => {this.setState({bulkSelectedSPCModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.bulkSelectedSPCUpdate.map(data => (
                                 data.id != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.markBulkSPCupdate(data.id, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.labtestName} (# ${data.appointmentId})`}</label>
                                </div> 
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.updateSPCToOrder()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkSelectedAcceptModal}
                    onHide={() => {this.setState({bulkSelectedAcceptModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.bulkSelectedAcceptUpdate.map(data => (
                                data.id != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.markBulkAcceptUpdate(data.id, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.labtestName} (# ${data.appointmentId})`}</label>
                                </div>
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.updateAcceptOrderBulk()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkSelectedTripStartModal}
                    onHide={() => {this.setState({bulkSelectedTripStartModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.bulkSelectedTripStartUpdate.map(data => (
                                data.id != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.markBulkTripStartUpdate(data.id, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.labtestName} (# ${data.appointmentId})`}</label>
                                </div>
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.updateTripStartOrderBulk()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkSelectedReachedModal}
                    onHide={() => {this.setState({bulkSelectedReachedModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.bulkSelectedReachedUpdate.map(data => (
                                data.id != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.markBulkReachedUpdate(data.id, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.labtestName} (# ${data.appointmentId})`}</label>
                                </div>
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.updateReachedOrderBulk()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
                    {
                        this.state.loader ? <p style={{textAlign:'center'}}>Loading...</p> : <p>
                        <div className="order-details-dashboard">
                            <div>
                                {
                                    !this.state.loader ? <HeaderSample titleCall={false} orderHeader={this.state.orderDetails.pendingOrders[0]} noCall={this.state.orderDetails.pendingOrders[0].noCall}
                                    onRescheduleRoute = {(id, time , reqId, city, did, orderId, name) => this.navigateToReschedule(id, time, reqId, city, did, orderId, name)}
                                    ></HeaderSample> : ''
                                }
                            </div>
                            <div>
                                <Container>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <div className="p-10">
                                                <div className="font-size-sm">
                                                    <i className="fa fa-flask width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                    TESTS
                                                    <button className="btn btn-default -m-t-10" onClick={() => this.showPackageInfoModal()}><svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="15px" height="15px">    <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z"/></svg></button>
                                                </div>
                                                <div className="font-size-smd bold">
                                                    <ol>
                                                        {this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].tests.map(elem => {
                                                            return <div><li className="display-flex" key={elem.testId}> {elem.testName} 
                                                                </li>
                                                                { 
                                                                elem.testDetails != null ? 
                                                                <div className="display-flex justify-content-space-between p-b-10">
                                                                    <div>
                                                                        { "Test Details : " + elem.testDetails}
                                                                     </div>   
                                                                </div>
                                                                : ""
                                                                }</div>
                                                        }) : ''}
                                                    </ol>
                                                    
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <div className="p-10">
                                                <div className="font-size-sm">
                                                    <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                    Customer Address
                                                </div>
                                                <div className="font-size-smd bold p-l-15">
                                                    {
                                                        this.state.orderDetails && this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine1 ? <span> {this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine1}, </span> : ''
                                                    }
                                                    {
                                                        this.state.orderDetails && this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine2 ? <span> {this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine2}, </span> : ''
                                                    }
                                                    {this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].patientDetails[0].landmark : ''}  -  {this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].patientDetails[0].pincode : ''}
                                                </div>
                                            </div>

                                            <div className="p-10">
                                                <div className="font-size-sm">
                                                    <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                    <span>Lab Address</span>
                                                    <button 
                                                    hidden = "hidden"
                                                    onClick={() => {
                                                        this.setState({
                                                            reassignLab: !this.state.reassignLab
                                                        })
                                                    }} className="btn btn-default btn-sm patientEdit m-b-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                                    </svg> 
                                                    </button>
                                                </div>
                                                <div className="font-size-smd bold p-l-15">
                                                
                                                {   
                                                    this.state.orderDetails && this.state.orderDetails.pendingOrders[0].labDetails && this.state.orderDetails.pendingOrders[0].labDetails.AssignedLab && !this.state.reassignLab ? 
                                                    <>
                                                    <span> {this.state.orderDetails.pendingOrders[0].labDetails.AssignedLab}, </span>
                                                    <span> {this.state.orderDetails.pendingOrders[0].labDetails.AssignedLabAddress 
                                                        + ", "
                                                        + this.state.orderDetails.pendingOrders[0].labDetails.AssignedLabPincode} </span>
                                                    </> : 
                                                    <Form onSubmit={(e)=>this.updateLabCenter(this.state.labId, e)}>
                                                        <Form.Group controlId="formGroupSelectLabCenter">
                                                            <Form.Label>Select a Lab Center</Form.Label>
                                                            <Form.Control as="select" onChange={(e)=>this.handleLabCenterChange(e)}>
                                                                <option value="">Select</option>
                                                                { 
                                                                    this.state.labCentersAvailable.map((each, idx) => (
                                                                        // {each.labId}
                                                                        <option key={idx} value={each.labid}>{each.labName + ', ' + each.labaddressline1}</option>
                                                                    ))
                                                                }
                                                            </Form.Control>
                                                        </Form.Group>
                                                        <Button variant="primary" type="submit"  className="text-align-center w-100"> Save </Button>
                                                    </Form>
                                                }
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            {
                                                (!this.state.acceptDisable) ? <div className="p-10 font-size-md bold text-align-center">
                                                    Please {!this.state.acceptDisable & this.state.labAssigned ? 'Accept' : 'Choose a Lab Center'} First
                                                </div> : <div>  {(this.state.showReachedButton) ? <div className="p-10 font-size-md bold text-align-center" onClick={() => this.handleCameraToggle()}>
                                                <button type="button" className="btn btn-outline-primary width-100 border-curve-10 m-t-10">
                                                    <span className="font-size-ml bold">Take Selfie Before Starting Trip</span> <i className=" fa fa-camera width-10" aria-hidden="true"></i>
                                                </button>
                                                    
                                                </div> : <div className="p-10 font-size-md bold text-align-center">
                                                    Image Updated SuccessFully
                                                </div>} </div>
                                            }

                                            <div>
                                                {this.checkCamera()}
                                            </div>
                                            <div>
                                                {this.showImage()}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                            <Col xs={12} md={12}>
                                                <div>
                                                    <p>
                                                    &nbsp;
                                                    </p>
                                                    </div>
                                             </Col>
                                    </Row>
                                    <Row>
                                            <Col xs={12} md={12}>
                                                <div>
                                                    <p>
                                                    &nbsp;
                                                    </p>
                                                    </div>
                                             </Col>
                                    </Row>
                                    <Row>
                                            <Col xs={12} md={12}>
                                                <div>
                                                    <p>
                                                    &nbsp;
                                                    </p>
                                                    </div>
                                             </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>


                            <div>
                                <Container>
                                    <Row>
                                        <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                                            <div className="display-flex justify-content-space-between p-b-10">
                                                <Col>
                                                    
                                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={this.props.history.goBack}>Back</button>
                                                    
                                                </Col>
                                                <Col >
                                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => this.routeToCancelPage()}>Reject</button>
                                                </Col>
                                                {(!this.state.acceptDisable && this.state.labAssigned) &&
                                                <Col >
                                                    
                                                    
                                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" disabled={this.state.acceptDisable || !this.state.labAssigned} onClick={() => this.acceptOrder()}>Accept</button>
                                                   
                                                </Col>
                                                }  
                                                
                                                
                                            </div>

                                            <div className="display-flex justify-content-space-between">
                                                <Col>
                                                    <Button variant="primary" size="md" block className="border-curve-10" disabled={this.state.showReachedButton} onClick={() => this.getAddrloc()}>
                                                        Navigate
                                                    </Button>
                                                </Col>
                                                {!this.state.showReachedButton &&
                                                <Col>
                                                    <Button variant="primary" size="md" block className="border-curve-10" disabled={this.state.showReachedButton} onClick={() => this.routeToSampleCollected(this.props.match.params.orderId)}>
                                                        I&apos;ve Reached
                                                    </Button>
                                              
                                                </Col>

                                                }
                                                
                                            </div>
                                        </div>
                                    </Row>
                                </Container>
                            </div>
                        </p>
                    }

                    {
                        this.toastComponent()
                    }
                {this.state.loadPackageDetails && < PackageDetails showPackageInfo={this.state.showPackageInfo} showPackageInfoModal={() => this.showPackageInfoModal()} appointmentId={this.state.orderDetails.pendingOrders[0].appointmentId} packageName={this.state.orderDetails.pendingOrders[0].tests[0].testName}/>}
                </div>
            </div>
        )

    }
}
export default geolocated({
    positionOptions: {
        enableHighAccuracy: true,
    },
    userDecisionTimeout: 50000,
})(OrderDetails);
